import { EbUser } from "./user";

export class SavedForm{
	ebSavedFormNum: number;
	ebModuleNum: number;
	ebCompNum: number;
	ebUser: EbUser;
	ebUserNum: number;
	formName: string;
	formValues: string;
	dateAjout: Date;
	url: string;
}


// WEBPACK FOOTER //
// ./src/app/classes/savedForm.ts